module.exports = __webpack_public_path__ + "media/Video 138c.427b7791.mp4";